import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import React from 'react';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import styles from './style.module.scss';

var DrawerNavigation =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DrawerNavigation, _React$Component);

  function DrawerNavigation() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, DrawerNavigation);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DrawerNavigation)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      open: false
    };

    _this.toggleDrawer = function (open) {
      return function () {
        _this.setState({
          open: open
        });
      };
    };

    return _this;
  }

  _createClass(DrawerNavigation, [{
    key: "render",
    value: function render() {
      return React.createElement(React.Fragment, null, React.createElement(IconButton, {
        className: styles.trigger,
        color: "inherit",
        "aria-label": "Menu",
        onClick: this.toggleDrawer(true)
      }, React.createElement(MenuIcon, null)), React.createElement(SwipeableDrawer, {
        anchor: this.props.from || 'left',
        open: this.state.open,
        onClose: this.toggleDrawer(false),
        onOpen: this.toggleDrawer(true)
      }, React.createElement("div", {
        className: styles.wrapper,
        tabIndex: 0,
        role: "button",
        onClick: this.toggleDrawer('left', false),
        onKeyDown: this.toggleDrawer('left', false)
      }, this.props.children)));
    }
  }]);

  return DrawerNavigation;
}(React.Component);

export default React.memo(DrawerNavigation);